import { render, staticRenderFns } from "./TaxonomyListItem.vue?vue&type=template&id=1b6f9bd2&scoped=true&"
import script from "./TaxonomyListItem.vue?vue&type=script&lang=js&"
export * from "./TaxonomyListItem.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyListItem.vue?vue&type=style&index=0&id=1b6f9bd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f9bd2",
  null
  
)

export default component.exports